import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { searchInterface } from 'src/app/util/interfaces/search';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root',
})
export class SearchToolService {
	private searchUrl: string = environment.baseApiUrl + 'tool/search/{search}';
	private searchPageUrl: string = environment.baseApiUrl + 'tool/search/{search}/count';

	constructor(
		private AuthLoginService: AuthLoginService,
		private http: HttpClient
	) {}

	headers = new HttpHeaders({
		Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken(),
		'Content-Type': 'application/json;charset=UTF-8',
	});

	search(
		search: string,
		page: number,
		searchType: string,
		itemsPerPage: number,
		sortedBy: string,
		sortDown: boolean
	): Observable<searchInterface> {
		const searchUrl = this.searchUrl.replace('{search}', search);
		return this.http
			.get<JSON[]>(searchUrl, {
				headers: this.headers,
				params: {
					page: page,
					itemsPerPage: itemsPerPage,
					filter: searchType,
					sortedBy: sortedBy,
					sortDown: sortDown,
				},
			})
			.pipe(
				map((searchRes: any) => {
					const newSearch: searchInterface = {
						request: [],
						kb: [],
						cmdb: [],
					};

					if (searchRes.request)
						for (const request of searchRes.request) {
							const temporary = {
								id: request.id,
								sla_remaining: <number>request.slaRemaining,
								service_type: request.service_type,
								scope: request.scope,
								category: request.category,
								topic: request.topic,
								solution_area: request.solution_area,
								status: request.status,
								summary: request.summary,
								id_enduser: request.idenduser,
								description: request.description,
								limit_date: request.limit_date,
								open_date: request.open_date,
								registered_by: request.registered_by,
								analyst: request.analyst,
								enduser: request.enduser,
								department: request.department,
								site: request.site,
								location: request.location,
							};

							for (let index = 0; index < Object.keys(request).length; index++) {
								const selObjectKey = Object.keys(request)[index];
								if (selObjectKey.startsWith('customfield_')) {
									temporary[selObjectKey] = request[selObjectKey];
								}
							}

							newSearch.request.push(temporary);
						}

					if (searchRes.kb)
						for (const kb of searchRes.kb) {
							const temporary = {
								id: kb.id,
								summary: kb.summary,
								solution_area: kb.solution_area,
							};

							newSearch.kb.push(temporary);
						}

					if (searchRes.cmdb)
						for (const cmdb of searchRes.cmdb) {
							const temporary = {
								id: cmdb.id,
								identification: cmdb.identification,
								label: cmdb.label,
								ci_type: cmdb.label,
								type: cmdb.type,
							};

							newSearch.cmdb.push(temporary);
						}

					return newSearch;
				})
			);
	}
}
